<template>
  <div>
    <b-input-group>
      <label-info
          v-if="false"
          id="email-address"
          label-name="Email Address"
          label-info="Please enter a valid email address to receive your words"
      />
      <b-button
          id="copy-to-clipboard"
          style="margin-top: 25px; cursor: pointer"
          variant="primary"
          @click="copytoClipboard">
       Copy
      </b-button>
    </b-input-group>
  </div>
</template>

<script>
import LabelInfo from "@/components/common/labelInfo";
export default {
  name: "Display_Export_Copy",
  components: {
    LabelInfo
  },
  created(){},
  mounted() {},
  props: {
    currIdx: {
      type: Number,
      required: false,
      default: 0
    },
    outputs:  {
      type: Array,
      required: false,
      default: ()=>{ return []}
    }
  },
  computed: {},
  methods: {
    copytoClipboard() {
      let copyText = this.generateBodyText();
      navigator.clipboard.writeText(
          copyText
      );
      const notif = {
        title:'The Word Copied',
        description: `Now you can paste it.`,
        variant: "success"
      };

      this.handleShowUserNotification(notif);
      this.$emit('words-copied');
    },
    generateBodyText(){
      let text="";
      if(!this.isEntireBook){
        //The Word
        let theWords = this.outputs[this.currIdx];
        if (theWords) {
          text = theWords.encouraging_words ? `THE WORDS \n${theWords.encouraging_words}` : "";
          text += theWords.scriptures ? this.generateTextScriptures(theWords.scriptures) : "";
          text += theWords.action_items ? this.generateTextActionItems(theWords.action_items) : "";
          text += theWords.parting_words ? `\n\n ${theWords.parting_words}` : "";
        }
      }
      return text;
    },
    generateTextScriptures(scriptures){
      let scriptureText = "\n\nSCRIPTURES\n";
      if(scriptures && Array.isArray(scriptures)){
       scriptures.forEach((aScripture)=>{
         scriptureText+=`${aScripture.text} - ${aScripture.book_chapter_vers ? aScripture.book_chapter_vers :'KJV' }\n`;
       })
      }
      return scriptureText;
    },
    generateTextActionItems(actionItems){
      let actionItemsText = "\n\nACTION ITEMS \n";
      if(actionItems && Array.isArray(actionItems)){
        actionItems.forEach((anActionItem)=>{
          actionItemsText+=`- ${anActionItem}\n`;
        })
      }
      return actionItemsText;
    },
    handleShowUserNotification(message) {
      this.$store.dispatch("user/showNotification", {
        title: message.title,
        description: message.description,
        variant: message.variant
      });
    },
  },
  data() {
    return {
      status:null,
      show:false,
      isEntireBook: false
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
